import React, { useState, useEffect } from 'react'
import { Panel, Button } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ProjectEvaluationForm from './ProjectEvaluationForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
// //import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function ProjectEvaluationWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  // const [isError, setIsError] = useState(false)
  // const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)

  // const { projectId } = useParams()

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = { ...data }
    setRequest(request)

    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)

    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <ProjectEvaluationForm
        schema={formSchema}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
      />

      <hr />

      <Button ripple appearance="ghost" onClick={handleSubmit(onSubmit)}>
        {formSchema.buttonText}
      </Button>

      <ConfirmWidget
        title={`ยืนยันการ${formSchema.buttonText}`}
        // confirmBtn={`ยืนยัน${formSchema.buttonText}`}
        // cancleBtn={`ยกเลิก${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
